import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SubHeading, MenuItem } from '../../../components/ClientPage';
import './SpecialMenu.css';

const SpecialMenu = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleViewMenu = () => {
    navigate('/menu');
  };

  const soups = t('house_specialties.soups', { returnObjects: true });
  const sushi_bowls = t('house_specialties.sushi_bowls', { returnObjects: true });
  return (
    <div className="app__specialMenu flex__center section__padding" id="menu">
      <div className="app__specialMenu-title">
        <SubHeading title={t('house_specialties.subHeading')} />
        <h1 className="headtext__cormorant">{t('house_specialties.title')}</h1>
      </div>

      <div className="app__specialMenu-menu">
        <div className="app__specialMenu-menu_item  flex__center">
          <p className="app__specialMenu-menu_heading">{t('house_specialties.soup_title')}</p>
          <div className="app__specialMenu_menu_items">
            {soups.map((soup, index) => (
              <MenuItem key={soup.title + index} title={soup.title} price={soup.price} tags={soup.tags} />
            ))}
          </div>
        </div>

        <div className="app__specialMenu-menu_img">
          <img src={'/assets/pho.png'} alt="menu__img" />
        </div>

        <div className="app__specialMenu-menu_item  flex__center">
          <p className="app__specialMenu-menu_heading">{t('house_specialties.sushi_bowl_title')}</p>
          <div className="app__specialMenu_menu_items">
            {sushi_bowls.map((bowl, index) => (
              <MenuItem key={bowl.title + index} title={bowl.title} price={bowl.price} tags={bowl.tags} />
            ))}
          </div>
        </div>
      </div>

      <div style={{ marginTop: 15 }}>
        <button type="button" className="custom__button" onClick={handleViewMenu}>
          {t('house_specialties.view_menu_btn')}
        </button>
      </div>
    </div>
  );
};

export default SpecialMenu;